import { dateWithoutHour, isWeekend, getWeekNumber } from "../../functions";
import { MonthlyTeamPlanningTimeSlot } from "./MonthlyTeamPlanningTimeSlot";

export const MonthlyTeamPlanningUser = (props) => {
    const { userName, userId, planning, allDates, selectedTimeSlots } = props;

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(...tsId, ctrlKey);
    };

    function isSelected(timeSlot) {
        return selectedTimeSlots.some(sel => timeSlot.id.includes(sel));
    };

    const mergedTimeSlots = (aDate) => {

        const planningOfDay = planning?.find((pl) => dateWithoutHour(pl.datePlanning).toDateString() == dateWithoutHour(aDate).toDateString());
        const mts = planningOfDay?.timeSlots.map((ts) => {
            return { 'id': [ts.id], 'hour_type_id': ts.hour_type_id, 'hour_type': ts.hour_type, 'start_date': ts.start_date, 'end_date': ts.end_date, 'state': ts.state };
        });

        let i = mts.length - 1;
        while (i > 0) {
            if (mts[i].hour_type.id === mts[i - 1].hour_type.id) {
                mts[i - 1].end_date = mts[i].end_date;
                mts[i - 1].id.push(...mts[i].id);
                mts.splice(i, 1);
            }
            i--;
        }

        return mts;
    };

    const percentDay = allDates().length > 0 ? (85 / allDates().length).toFixed(2) : 0;
    const percentUsr = (100 - (percentDay * allDates().length)).toFixed(2);
    const stylePercentDay = {
        width: percentDay + '%',
    }
    const stylePercentUsr = {
        width: percentUsr + '%',
    }

    return (
        <div className="w-full p-0 flex flex-wrap m-0 group">
            <div style={stylePercentUsr} className="h-full flex shrink text-left text-xm align-top p-1 gap-1 w-full">{userName}</div>
            {
                allDates().map((day, index) => {
                    return <div key={index} style={stylePercentDay} className={"h-full flex text-center align-top p-px gap-px w-full " + (isWeekend(day) ? "bg-green-50" : "bg-white")}>
                        {mergedTimeSlots(day).map((timeSlot, index) =>
                            <MonthlyTeamPlanningTimeSlot
                                key={index}
                                timeSlot={timeSlot}
                                onClickTimeSlots={handleClickTimeSlots}
                                selected={isSelected(timeSlot)}
                            />
                        )}
                    </div>
                })
            }
        </div>
    );
};
